import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createOfferPrice(
  parentId: string,
  masterBlockId?: MasterBlockId,
): OfferPriceInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.OfferPrice, parentId, masterBlockId),
    nameFontSize: 17,
    nameLineHeight: 16,
    nameColor: 'rgba(0,0,0,1)',
    amountFontSize: 17,
    amountLineHeight: 16,
    amountColor: 'rgba(0,0,0,1)',
    descriptionFontSize: 14,
    descriptionLineHeight: 32,
    descriptionColor: 'rgba(0,0,0,1)',
  }
}
